// Sign in with Apple — the browser half of the v2 flow.
//
// Apple posts to the v2 API (siteSetting.apple_redirectURI), the API verifies
// the sign-in with Apple and sends the browser to /redirect?code=<one-time
// code>. AppleRedirect trades { code, state } at v2 user/socialLogin.
//
// `state` ties that code to THIS tab: it is minted here before the trip to
// Apple, echoed back by Apple to the API, and must match when the code is
// redeemed — so nobody can log a victim's browser into their own account by
// sending them a /redirect link. One value per tab, shared by every Apple
// button on the page, so two buttons never disagree.
const KEY = 'appleSignInState';

function randomHex(bytes) {
    const a = new Uint8Array(bytes);
    window.crypto.getRandomValues(a);
    return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** The state to hand to <AppleLogin state=…>. */
export function appleSignInState() {
    try {
        let s = sessionStorage.getItem(KEY);
        if (!s) {
            s = randomHex(16);
            sessionStorage.setItem(KEY, s);
        }
        return s;
    } catch (e) {
        return '';
    }
}

/** The state this tab started with (read on /redirect). */
export function currentAppleSignInState() {
    try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; }
}

/** Forget it once the sign-in is finished, so the next one gets a fresh value. */
export function clearAppleSignInState() {
    try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ }
}
